import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { COMPANY } from '../mock';

export default function CtaBanner() {
  const navigate = useNavigate();
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-[#e11d2c] text-white p-8 sm:p-12 lg:p-16">
          <div className="absolute -top-24 -right-24 w-[360px] h-[360px] rounded-full bg-white/10 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-[360px] h-[360px] rounded-full bg-black/15 blur-3xl pointer-events-none" />
          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="text-[11px] tracking-[0.22em] uppercase font-semibold opacity-85">Ready to ride?</div>
              <h3 className="font-display mt-3 text-[34px] sm:text-[44px] lg:text-[52px] font-black leading-[1.02] tracking-tight">
                Visit our showroom or take a virtual tour today.
              </h3>
              <p className="mt-4 text-white/85 max-w-xl text-[15px]">
                Speak with a sales specialist, schedule a test drive, or apply for financing — we’ll have you in your next car faster than you think.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col gap-3">
              <Button onClick={() => navigate('/inventory')} className="btn-primary bg-black hover:bg-black/90 text-white rounded-full h-12 px-7 font-semibold text-[14px] inline-flex items-center justify-center">
                Browse Cars <ArrowRight size={16} className="ml-2" />
              </Button>
              <a href={`tel:${COMPANY.phone}`} className="bg-white text-[#e11d2c] hover:bg-white/90 rounded-full h-12 px-7 font-semibold text-[14px] inline-flex items-center justify-center gap-2 transition-colors">
                <Phone size={15} /> {COMPANY.phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
